import { localStorageStrategy, sessionStorageStrategy, StateStorage } from '@ngneat/elf-persist-state';

export type PStateStorage = StateStorage;
export const pLocalStorageStrategy: PStateStorage = localStorageStrategy;
export const pSessionStorageStrategy: PStateStorage = sessionStorageStrategy;
